import { error } from "console";

export const wailistPageContent = {
    en: {
        hero:{
            title: "Revimo Prelaunch",
            heading: "Reserve your place for smarter physiotherapy.",
            description: `Join the early waitlist for Revimo, platform that 
            helps you work better and smarter!`,
            list1: "Create costum sessions for your patients.",
            list2: "Discover new exercises and expand your horizion.",
            list3: "Create yourself more time for patients that need you the most.",
        },
        form: {
            title: "Join the waitlist",
            description: `Get early email
                  updates about Revimo. No payment now, just reserve
                  your spot.`,
            calling: "How should we call you?",
            calling2: "Whats your licence number?",
            license: "License number",
            name: "Name",
            get_e: "I want to receive email updates about Revimo and the launch.",
            get_d: "Reserve my 30% launch discount (no payment now, only when we launch)",
            warning: `By joining, you agree that we can store your email for
                        pre‑launch communication. You can opt out of emails at any time.`,
        },
        joining1: "Joining...",
        joining2: "Join the waitlist",
        on_list: "You’re on the list 🎉",
        thanks: "Thank you for reserving your place for Revimo.",
        add_info: `We’ll email you about the launch and
                  an invitation to share more feedback so you can help shape
                  the platform.`,
        add_o_e: "Add another email",
        error: "Something went wrong. Please try again in a moment."
    },
    sl: {
    hero: {
      title: "Revimo – predzagonska čakalna lista",
      heading: "Rezervirajte si mesto za pametnejšo fizioterapijo.",
      description: `Pridružite se zgodnji čakalni listi za Revimo - platforma, ki vam omogoča boljše in pametnejše delo.`,
      list1: "Ustvarite personalizirane seje za paciente.",
      list2: "Odkrite nove vaje in razširite svoje znanje.",
      list3: "Ustvarite si več časa za paciente, ki vas najbolj potrebujejo",
    },
    form: {
      title: "Prijava na čakalno listo",
      description: `Naročite se na zgodnja e‑poštna
                  obvestila o Revimu. Plačilo ni potrebno zdaj, le
                  rezervirate si svoje mesto.`,
      calling: "Kakšen bo tvoj vzdevek?",
      calling2: "Tvoja licenčna številka.",
      license: "Licenčna številka",
      name: "Ime",
      get_e:
        "Želim prejemati e‑poštna obvestila o Revimu in datumu zagona.",
      get_d:
        "Želim si rezervirati 30 % popust ob zagonu (brez plačila zdaj, šele ob zagonu storitve).",
      warning: `S prijavo se strinjate, da lahko vaš e‑poštni naslov
                        uporabimo za obveščanje pred zagonom. Od prejemanja
                        obvestil se lahko kadarkoli odjavite.`,
    },
    joining1: "Prijavljamo...",
    joining2: "Prijava na čakalno listo",
    on_list: "Dodani ste na čakalno listo 🎉",
    thanks: "Hvala, ker ste si rezervirali mesto na Revimo.",
    add_info: `Po e‑pošti vas bomo obvestili o zagonu, 
    vam poslali vprašalnik, s katerim boste lahko
                      pomagali soustvarjati platformo.`,
    add_o_e: "Dodaj še en e‑poštni naslov",
    error: "Nekaj je šlo narobe... Prosim da poiskusite ponovno."
  },
} as const;